import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar as CalendarIconFull, Users, UserCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ViewModeControls = ({ viewMode, onViewModeChange, ViewModes }) => {
  const navigate = useNavigate();

  const handleClick = (mode) => {
    onViewModeChange(mode);
    if (mode === ViewModes.BY_DATE) navigate("/date");
    if (mode === ViewModes.BY_GROUP) navigate("/group");
    if (mode === ViewModes.BY_TEACHER) navigate("/teacher");
  };

  return (
    <div className="flex justify-center space-x-2">
      <Button
        variant={viewMode === ViewModes.BY_DATE ? "default" : "outline"}
        onClick={() => handleClick(ViewModes.BY_DATE)}
        className="flex-1"
      >
        <CalendarIconFull className="mr-2 h-4 w-4" />
        По даті
      </Button>
      <Button
        variant={viewMode === ViewModes.BY_GROUP ? "default" : "outline"}
        onClick={() => handleClick(ViewModes.BY_GROUP)}
        className="flex-1"
      >
        <Users className="mr-2 h-4 w-4" />
        По групі
      </Button>
      <Button
        variant={viewMode === ViewModes.BY_TEACHER ? "default" : "outline"}
        onClick={() => handleClick(ViewModes.BY_TEACHER)}
        className="flex-1"
      >
        <UserCheck className="mr-2 h-4 w-4" />
        По викладачу
      </Button>
    </div>
  );
};

export default ViewModeControls;
